module.exports = __webpack_public_path__ + "img/government-backing.053f17d.jpg";